export const hora = [
  {
    label: "Id",
    name: "idhora",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Personal",
    name: "idpersonal",
    type: "personal",
    showOnList: true,
    // Al crear, quien puede cargar horas de otros elige la persona. Una vez
    // cargada, reasignarla altera el parte de dos personas a la vez, asi que
    // el backend lo reserva al admin y aca se bloquea el selector.
    readonly: (record, roles) => !!record.idhora && !roles.includes("admin"),
  },
  {
    label: "Fecha",
    name: "fecha",
    type: "DATE",
    showOnList: true,
  },
  {
    label: "Horas",
    name: "horas",
    type: "DECIMAL",
    showOnList: true,
    min: 0,
    max: 12,
  },
  {
    label: "Tarea",
    name: "idtarea",
    type: "tarea",
    showOnList: true,
  },
  {
    label: "Proyecto",
    name: "idpresupuesto",
    type: "presupuesto",
    showOnList: true,
    filters: {
      estado: {
        value: ["Approved", "Waiting"],
        type: "STRINGINLIST",
      },
    },
  },
  {
    label: "Comentarios",
    name: "comentarios",
    type: "LONGSTRING",
    showOnList: true,
  },
];
